// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1517":"7afa7647","3898":"7afa7647","6279":"7afa7647","8184":"7afa7647","8660":"7afa7647"}[chunkId] + ".chunk.css";
};